import { Trans } from "next-i18next";
import React from "react";
import ConnectMenu from "../../Header/connect-button";

interface ConnectWalletProps {
  handleLogin: () => void;
}

function ConnectWallet({ handleLogin }: ConnectWalletProps) {
  return (
    <div className="w-full flex flex-col sm:flex-row md:flex-col lg:flex-row gap-6 place-content-between">
      <div className="bodyText">
        <Trans
          components={{
            b: <span className="font-inter-medium" />,
          }}
          i18nKey="classroom:connectWallet"
        />
      </div>
      <ConnectMenu
        handleLogin={handleLogin}
        stretch
        closeMobileMenu={() => null}
      />
    </div>
  );
}

export default ConnectWallet;
